import React, { FC, useEffect, useState } from 'react';
import {
  ChoferFormSchema,
  choferModelToFormSchema,
} from '../models/ChoferFormSchema';
import useChoferProfile from '../hooks/useChoferProfile';
import ChoferFormTurno from './ChoferForm/ChoferFormTurno';
import { VisiblePages } from '../models/choferPages';
import { ChoferModelSinTurno } from '../models/Chofer';

interface ChoferTurnCreateProps {
  createdChofer: ChoferModelSinTurno;
  setCurrentStep: (
    currentStep: 'general' | 'personal' | 'turno' | 'vencimientos'
  ) => void;
  setVisiblePage: (visiblePage: VisiblePages) => void;
}

const ChoferTurnCreate: FC<ChoferTurnCreateProps> = ({
  createdChofer,
  setVisiblePage,
  setCurrentStep
}) => {
  const { choferQuery } = useChoferProfile(createdChofer.id);

  const [choferFormValues, setChoferFormValues] =
    useState<ChoferFormSchema | null>(null);

  const handleTurnosUpdated = async () => {
    await choferQuery.reload();
  };

  const handleFinish = () => {
    setCurrentStep('general');
    setVisiblePage(VisiblePages.TABLE);
  };

  useEffect(() => {
    if (choferQuery.data) {
      setChoferFormValues(choferModelToFormSchema(choferQuery.data));
    }
  }, [choferQuery.data]);

  useEffect(() => {
    if (!choferFormValues) {
      handleTurnosUpdated();
    }
  }, [choferFormValues]);

  if (!choferFormValues) {
    return null;
  }
  return (
    <ChoferFormTurno
      driverId={createdChofer.id}
      initialValues={
        choferFormValues?.turno 
      }
      onTurnosUpdated={handleTurnosUpdated}
      handleFinish={handleFinish}
    />
  );
};

export default ChoferTurnCreate;
